// extracted by mini-css-extract-plugin
module.exports = {"DoubleCalander":"datepicker_DoubleCalander__3Iq_X"};